
var ZVST_KEY = "XNpMRQ";
var ZVST_LIST = window.ZVShop.listId;

function zvStSay(t){ var m=document.getElementById('zvStMsg'); if(m) m.textContent=t; }

function zvStPost(path, body){
  return fetch('https://a.klaviyo.com/client/'+path+'/?company_id='+ZVST_KEY, {
    method:'POST',
    headers:{'Content-Type':'application/json','revision':'2024-10-15'},
    body:JSON.stringify(body)
  }).then(function(r){ if(r.status===202||r.ok) return true; throw new Error(path+' '+r.status); });
}

function zvStJoin(){
  var email=document.getElementById('zvStEmail').value.trim();
  var b=document.getElementById('zvStGo');
  zvStSay('');
  if(!email||email.indexOf('@')<1||email.indexOf('.')<0){ zvStSay('Please enter a valid email address.'); return; }
  b.disabled=true; b.textContent='One moment…';

  // Timezone tells us roughly where they are, so UK and US can be told apart later
  // without asking them a question they have no reason to answer.
  var tz='';
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch(e) { tz=''; }

  var props={ signup_source:'instagram-bio', browser_timezone:tz, saw_price:((window.ZVShop&&window.ZVShop.country==='GB')?'no (UK)':'yes') };

  // Both calls are required. /client/subscriptions/ sets consent and list membership but
  // writes NO properties onto a profile that already exists (proven 2026-08-11).
  // /client/profiles/ writes the fields on new and existing profiles alike.
  var sub={ data:{ type:'subscription', attributes:{ profile:{ data:{ type:'profile', attributes:{ email:email, properties:props } } } }, relationships:{ list:{ data:{ type:'list', id:ZVST_LIST } } } } };
  var prof={ data:{ type:'profile', attributes:{ email:email, properties:props } } };

  zvStPost('subscriptions', sub)
    .then(function(){ return zvStPost('profiles', prof); })
    .then(function(){
      document.getElementById('zvStForm').style.display='none';
      document.getElementById('zvStNote').style.display='none';
      document.getElementById('zvStOk').classList.add('show');
      if(window.fbq){ var zvLp={content_name:'Instagram bio'}; if(window.ZVAM&&typeof window.ZVAM.lead==='function'){ window.ZVAM.lead(zvLp,{email:email}); } else { fbq('track','Lead',zvLp); } }
    })
    .catch(function(){
      b.disabled=false; b.textContent="Tell me when it's real";
      zvStSay('Something went wrong. Please try again.');
    });
}

document.addEventListener('keydown', function(e){
  if(e.key==='Enter' && document.activeElement && document.activeElement.id==='zvStEmail') zvStJoin();
});

// The price is shown per market. Never type a figure into this page again:
// the first paint uses the map below so there is no flicker, then the real
// price is read from the product and overwrites it. A price change in Shopify
// therefore reaches this page on its own.
(function(){
  var el = document.getElementById('zvStPrice');
  if (!el) return;
  var SYMBOL = { USD:'$', GBP:'£', EUR:'€' };
  var FIRST_PAINT = { USD:6900, GBP:4900 };
  var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

  function show(cents){
    var v = cents / 100;
    el.textContent = (SYMBOL[code] || code + ' ') + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  if (FIRST_PAINT[code]) show(FIRST_PAINT[code]);

  fetch('/products/the-pdrn-serum.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){ if (p && typeof p.price === 'number') show(p.price); })
    .catch(function(){});
})();

;

// Market-aware price. Do not type a figure into this page again.
(function(){
  var SYMBOL = { USD:'$', GBP:'£', EUR:'€' };
  var FIRST_PAINT = { USD:6900, GBP:4900 };
  var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fmt(cents){
    var v = cents / 100;
    return (SYMBOL[code] || code + ' ') + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function paint(cents){
    window.ZV_PRICE = fmt(cents);
    var n = document.querySelectorAll('.zv-price-auto');
    for (var i = 0; i < n.length; i++) n[i].textContent = window.ZV_PRICE;
  }
  if (FIRST_PAINT[code]) paint(FIRST_PAINT[code]);
  fetch('/products/the-pdrn-serum.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){ if (p && typeof p.price === 'number') paint(p.price); })
    .catch(function(){});
})();
